<h2 mat-dialog-title>Material para {{'Pedido' | translate}}</h2>

<mat-label *ngIf="isLoading"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
<div mat-dialog-content *ngIf="!isLoading">

  <form [formGroup]="formGroup" *ngIf="data.CanEditMaterial">

    <div fxLayout="row stretch" fxLayout.xs="column">
      <div fxFlex={{getMaterialWidth()}} fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <input type="text" placeholder="Material*" aria-label="Material" matInput [matAutocomplete]="Material"
            formControlName="Material">
          <i [ngStyle]="{'display': isMaterialAutoSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
            style="position: absolute; right: 0"></i>
            <mat-error *ngIf="!formGroup.controls['Material'].valid && formGroup.controls['Material'].touched" >
              {{ getErrorMaterial() }}
            </mat-error>
        </mat-form-field>
        
        <mat-autocomplete  panelWidth="auto" #Material="matAutocomplete"  [displayWith]="displayMaterial" >
          <mat-option  *ngFor="let s of filteredMaterialList" [value]="s">
            {{s.Nombre}}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div fxFlex=10 fxFlex.xs=100 class="flex-item btn-add" *ngIf="canCreateNewMaterial" style="margin-top: 20px !important;">
        <button mat-raised-button (click)="addNewMaterial()" title="Agregar nuevo material">
          <i class="fa fa-plus fa-1x"></i>
        </button>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Detalle del Material</mat-label>
          <input matInput formControlName="Detalle" maxlength="150">
          
        </mat-form-field>
      </div>

      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label class="text-style">Cantidad*</mat-label>
          <input class="text-style" matInput type="number" formControlName="Cantidad" (keyup.enter)="onGuardar()">
          <mat-error
            *ngIf="!formGroup.controls['Cantidad'].valid && formGroup.controls['Cantidad'].touched">
            {{ getErrorCantidad() }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <input type="text" placeholder="Rubro Contable*" aria-label="RubroContable" matInput [matAutocomplete]="RubroContable"
            formControlName="RubroContable">
          <i [ngStyle]="{'display': isRubroContableAutoSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
            style="position: absolute; right: 0"></i>
            <mat-error *ngIf="!formGroup.controls['RubroContable'].valid">
              {{ getErrorRubroContable() }}
            </mat-error>
        </mat-form-field>
        <mat-autocomplete panelWidth="auto" #RubroContable="matAutocomplete" [displayWith]="displayRubroContable">
          <mat-option *ngFor="let s of rubroContableList" [value]="s">
            {{s.Codigo + '. ' + s.Nombre }}
          </mat-option>
        </mat-autocomplete>
      </div> -->


      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label *ngIf="!isRubroContableAutoSearching">{{'Rubro Contable' | translate}} Origen*</mat-label>
          <mat-label *ngIf="isRubroContableAutoSearching">Cargando...</mat-label>
          <mat-select formControlName="RubroContable" >
            <mat-option *ngFor="let s of rubroContableList" [value]="s"> {{s.Codigo + '. ' + s.Nombre }}</mat-option>
          </mat-select>
          <mat-error
            *ngIf="!formGroup.controls['RubroContable'].valid && formGroup.controls['RubroContable'].touched">
            {{ getErrorRubroContable() }}
          </mat-error>
        </mat-form-field>
      </div>


      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Fecha Necesidad*</mat-label>
          <input matInput (dateChange)="checkToday()" [matDatepicker]="fechaNecesidadPicker" formControlName="FechaNecesidad"
            (click)="fechaNecesidadPicker.open()">
          <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNecesidadPicker">
          </mat-datepicker-toggle>
          <mat-datepicker-toggle  style="display:inline-block;" matSuffix (click)="clearDate('FechaNecesidad')">
            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #fechaNecesidadPicker></mat-datepicker>
          <mat-error
            *ngIf="!formGroup.controls['FechaNecesidad'].valid && formGroup.controls['FechaNecesidad'].touched">
            {{ getErrorFechaNecesidad() }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Fecha Límite*</mat-label>
          <input matInput (dateChange)="checkDate()" [matDatepicker]="fechaLimitePicker" formControlName="FechaLimite"
            (click)="fechaLimitePicker.open()">
          <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaLimitePicker">
          </mat-datepicker-toggle>
          <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaLimite')">
            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #fechaLimitePicker></mat-datepicker>
          <mat-error
            *ngIf="!formGroup.controls['FechaLimite'].valid && formGroup.controls['FechaLimite'].touched">
            {{ getErrorFechaLimite() }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Observación adicional</mat-label>
          <input matInput formControlName="Observacion" (keyup.enter)="onGuardar()" maxlength="150">
          <mat-error
            *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
            {{ getErrorObservacion() }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>    
  </form>

  <ng-container *ngIf="!data.CanEditMaterial">

    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>{{'Material' | translate}}</b>: {{data?.PedidoItemDto?.MaterialNombre}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Detalle</b>: {{data?.PedidoItemDto?.Detalle}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Cantidad</b>: {{data?.PedidoItemDto?.Cantidad | number:'1.1-2'}} {{data?.PedidoItemDto?.MaterialUnidadMedida}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>
      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Rubro Contable</b>: {{data?.PedidoItemDto?.RubroContableNombre}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Fecha Necesidad</b>: {{data?.PedidoItemDto?.FechaNecesidad | date:'dd/MM/yyyy' }}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>
      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Fecha Límite</b>: {{data?.PedidoItemDto?.FechaLimite | date:'dd/MM/yyyy' }}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=100 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Observaciones</b>: {{data?.PedidoItemDto?.Observacion}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

    </div>

  </ng-container>

</div>

<br />

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" (click)="onGuardar()" class="zb-button" *ngIf="data.CanEditMaterial">{{buttonAcceptText}}</button>
    <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">{{buttonCancelText}}</button>
  </div>
</div>